
import { StructureDto } from '@/endpoints/models'
import { DeleteModal } from '@/pages/User/pages/Home/components/DeleteModal'
import { BatchEdit } from '@/pages/User/pages/Home/components/TreePanel/components/BatchEdit/BatchEdit'
import { BatchUnlockModal } from '@/pages/User/pages/Home/components/TreePanel/components/BatchUnlockModal'
import { DeleteNodesModal } from '@/pages/User/pages/Home/components/TreePanel/components/DeleteNodesModal'
import { DuplicateNodeModal } from '@/pages/User/pages/Home/components/TreePanel/components/DuplicateNodeModal'
import { ImportStructureModal } from '@/pages/User/pages/Home/components/TreePanel/components/ImportStructureModal'
import { MassSqlExportModal } from '@/pages/User/pages/Home/components/TreePanel/components/MassSqlExportModal'
import { UnlockModal } from '@/pages/User/pages/Home/components/UnlockModal'
import { cancelEditingTab } from '@/store/modules/tab/actions'
import { ItemMenuDialog } from '@/types'

export const deleteNodesModalDialog: ItemMenuDialog = (opened, onClose) =>
	opened && <DeleteNodesModal onClose={onClose} />

export const deleteNodeDialog: ItemMenuDialog = (
	opened,
	onClose,
	node,
	_dispatch,
	_selectedNodes,
	onRefresh,
) =>
	opened && (
		<DeleteModal
			node={node as StructureDto}
			onClose={onClose}
			refetch={onRefresh}
		/>
	)

export const batchEditDialog: ItemMenuDialog = (opened, onClose, node) =>
	opened && <BatchEdit onClose={onClose} node={node as StructureDto} />

export const importStructureModalDialog: ItemMenuDialog = (
	opened,
	onClose,
	node,
) => opened && <ImportStructureModal node={node} onClose={onClose} />

export const duplicateNodeModalDialog: ItemMenuDialog = (
	opened,
	onClose,
	node,
) => opened && <DuplicateNodeModal node={node} onClose={onClose} />

export const massSqlExportModalDialog: ItemMenuDialog = (
	opened,
	onClose,
	node,
	_unused,
	selectedNodes,
) =>
	opened && (
		<MassSqlExportModal
			node={node}
			onClose={onClose}
			selectedNodes={selectedNodes}
			isSqlGen
		/>
	)

export const unlockNodeModalDialog: ItemMenuDialog = (
	opened,
	onClose,
	node,
	dispatch,
) =>
	opened && (
		<UnlockModal
			node={node as StructureDto}
			onConfirm={() =>
				dispatch && dispatch(cancelEditingTab(node as StructureDto))
			}
			onClose={onClose}
		/>
	)

export const batchUnlockDialog: ItemMenuDialog = (
	opened,
	onClose,
	_node,
	_dispatch,
	_selectedNodes,
	onRefresh,
) =>
	opened && <BatchUnlockModal onClose={onClose} onUnlockSuccess={onRefresh} />
